module.exports = __webpack_public_path__ + "img/check-circle.a3ca40ee.svg";